import { ApiHandlingService } from "../../services/vs-services/api-handler.service";
import { GlobalVariable } from "./globals";
export class ApiEndpoints {

// Main Backend URLs
public static BASE_URL = GlobalVariable.BASE_API_URL;
// public static BASE_URL = GlobalVariable.MP_URL;
// public static BASE_URL = ;
public static FLASK_LOCAL_URL = GlobalVariable.BASE_CSV_URL;
// public static FLASK_LOCAL_URL = 'http://127.0.0.1:5000/';

public static genAwb = ApiEndpoints.FLASK_LOCAL_URL + 'generateAwb'

// airline-schedule-controller
public static AIRLINE_SCHD_CSV_SAVE = ApiEndpoints.BASE_URL + 'arln-schdl/csv/save';
public static GET_AIRLINE_SCHD = ApiEndpoints.BASE_URL + 'arln-schdl/data-by-pagination-search/get';
public static CUSTOMIZE_AIRLINE = ApiEndpoints.BASE_URL + 'arln-schdl/by-arln-id-schdl-data-for-estmtn/get';
public static GET_AIRLINE_LIST_BY_MSTPRC = ApiEndpoints.BASE_URL + 'arln-schdl/list-by-mstrprc-id/get';
public static AIRLINE_SCHD_UPDATE = ApiEndpoints.BASE_URL + 'arln-schdl/update';
public static AIRLINE_BY_SCHD_ID = ApiEndpoints.BASE_URL + 'arln-schdl/by-schdl-id/get';
public static CUSTOM_AIRLINE = ApiEndpoints.BASE_URL + 'arln-schdl/custom-route/get';
public static FIRST_CUSTOM_ROUTE = ApiEndpoints.BASE_URL +'arln-schdl/first-custom-route/get';
public static OTHER_CUSTOM_ROUTE = ApiEndpoints.BASE_URL +'arln-schdl/other-custom-route/get';
public static AIRLINE_NAMES_BY_EMAIL = ApiEndpoints.BASE_URL + 'arln-schdl/by-email-airline-name/get';

// registration-controller
public static REGISTER_URL = ApiEndpoints.BASE_URL + 'registration/register';
public static LOGIN_URL = ApiEndpoints.BASE_URL + 'registration/login';
public static APPROVE_DISAPPROVE = ApiEndpoints.BASE_URL + 'registration/user/approve';
public static ALL_USER_DATA = ApiEndpoints.BASE_URL + 'registration/get/all';
public static EMAIL_OTP_URL = ApiEndpoints.BASE_URL + 'registration/otp/resend';
public static VERIFY_OTP_URL = ApiEndpoints.BASE_URL + 'registration/otp/verify';
public static USER_REGISTERED_DATA = ApiEndpoints.BASE_URL + 'registration/get';
public static MAKE_ADMIN = ApiEndpoints.BASE_URL + 'registration/adminapprove';
public static GENERATE_FORGOT_LINK = ApiEndpoints.BASE_URL + 'registration/forgot-password';
public static VERIFY_TOKEN_PASSWORD = ApiEndpoints.BASE_URL + 'registration/verify-token/update-password';
public static VERIFY_TOKEN = ApiEndpoints.BASE_URL + 'registration/verify-token';

// contact-us-controller
public static CONTACT_US_URL = ApiEndpoints.BASE_URL + 'contactus/save';

// shipping-controller
public static BOOK_CARGO_URL = ApiEndpoints.BASE_URL + 'shipment/save';
public static UPDATE_SHIPMENT = ApiEndpoints.BASE_URL + 'shipment/update';
public static UPDATE_SHIPMENT_PCKUPDTE = ApiEndpoints.BASE_URL + 'shipment/pickupdate/update';
public static VIEW_SHIP_BY_ID = ApiEndpoints.BASE_URL + 'shipment/get';
public static GET_BKID_BY_SHIPID = ApiEndpoints.BASE_URL + 'shipment/merge/get-bookid';
public static UPDATE_STATUS = ApiEndpoints.BASE_URL + 'shipment/status/update';
public static DELETE_DIMENSION = ApiEndpoints.BASE_URL + 'shipment/merge/delete-dimension';
public static GENERATE_BOOKING_FROM_EMAIL = ApiEndpoints.BASE_URL + 'shipment/shipment-data-by-email/get';
public static GET_ALL_SHIPMENT_CONCAT = ApiEndpoints.BASE_URL + 'shipment/concat-get/all';

// booking-controller
public static VIEW_ALL_BOOKINGS = ApiEndpoints.BASE_URL + 'booking/get/all';
public static EXPORT_BOOKINGS_EXCEL = ApiEndpoints.BASE_URL + 'booking/export/excel'; // Export bookings to Excel with date range filter
public static VIEW_ALL_USER_BOOKINGS = ApiEndpoints.BASE_URL + 'booking/by-email/get';
public static UPDATE_BOOKING_STATUS = ApiEndpoints.BASE_URL + 'booking/status/update';
public static GET_BKNG_BY_ID = ApiEndpoints.BASE_URL + 'booking/get';
public static UPDATE_BOOKING = ApiEndpoints.BASE_URL + 'booking/update';
public static UPDATE_TOTAL_PRICE = ApiEndpoints.BASE_URL + 'booking/totalprice/update';
public static GET_BOOKING_HISTORY = ApiEndpoints.BASE_URL + 'booking/booking-history/get/all';
public static SAVE_BKNG_MCFWD_RELTN = ApiEndpoints.BASE_URL + 'booking/bkng-frwrdr-mcrfrwrdr-rlstn/save';
public static GET_BKNG_MCFWD_RELTN = ApiEndpoints.BASE_URL + 'booking/bkng-frwrdr-mcrfrwrdr-rlstn/get';
public static GET_BKNG_OF_MCFWD_FOR_GSA = ApiEndpoints.BASE_URL + 'booking/all-mcrshpr-bkng-for-gsa/get';
public static SEND_DISCOUNT = ApiEndpoints.BASE_URL + 'booking/edit-frtRt-dscnt/save' ;
public static CHECK_DOC_STATUS = ApiEndpoints.BASE_URL + 'booking/chck-pymnt-accss/get';
public static CUSTOM_AIRLINE_UPDATE = ApiEndpoints.BASE_URL + 'booking/custom-airline/update';
public static CUSTOM_SHIPMENT_SAVE = ApiEndpoints.BASE_URL + 'booking/custom-shipment/update';
public static BOOKING_CANCEL_REQUEST = ApiEndpoints.BASE_URL + 'booking/cancel-request';

// airline-list-controller
public static ADD_AIRLINE_URL = ApiEndpoints.BASE_URL + 'saveairlinelistdata';
public static ADD_AIRLINES_AND_AIRCRAFT = ApiEndpoints.BASE_URL + 'airline/flight-schedule/save';
public static ADD_FLIGHT_SCH_CSV = ApiEndpoints.BASE_URL + 'airline/flight-schedule/csv/save';
public static GET_ALL_AIRLINES = ApiEndpoints.BASE_URL + 'airline/flight-schedule/get/all';
public static GET_ALL_AIRCRFTS = ApiEndpoints.BASE_URL + 'airline/flight-schedule/getallaircrft';
public static UPDATE_AIRLINES = ApiEndpoints.BASE_URL + 'airline/flight-schedule/update';
public static SAVE_ARLN_GSA_RLTN = ApiEndpoints.BASE_URL + 'gsa-airline-rel/save';
public static GET_ARLN_GSA_RLTN = ApiEndpoints.BASE_URL + 'gsa-airline-rel/get/all';
public static DELETE_ARLN_GSA_RLTN = ApiEndpoints.BASE_URL + 'gsa-airline-rel/delete';

// profile-controller
public static USER_PROFILE_DATA = ApiEndpoints.BASE_URL + 'profile/get';
public static UPDATE_PROFILE = ApiEndpoints.BASE_URL+ 'profile/update';
public static GET_IDS_BY_EMAIL = ApiEndpoints.BASE_URL + 'profile/ids-by-email/get';
public static GET_ALL_PROFILE = ApiEndpoints.BASE_URL + 'profile/get/all';

// masterprice-controller
public static VIEW_MASTERPRICE_BY_ID = ApiEndpoints.BASE_URL + 'masterprice/get';
public static GET_AIRLINE_IN_MASTERPRICE = ApiEndpoints.BASE_URL + 'masterprice/merge/airlines/get';
public static UPDATE_MASTERPRICE = ApiEndpoints.BASE_URL + 'masterprice/update';
public static VIEW_ALL_MASTERPRICE = ApiEndpoints.BASE_URL + 'masterprice/get/all';
public static SAVE_MASTER_DATA = ApiEndpoints.BASE_URL + 'masterprice/save';
public static GET_ESTIMATE = ApiEndpoints.BASE_URL +'masterprice/merge/estimate/get';
// public static GET_ESTIMATE_COUNT = ApiEndpoints.BASE_URL + 'masterprice/merge/estimate/count/get'
public static GET_MY_MASTERPRICE = ApiEndpoints.BASE_URL + 'masterprice/by-email/get-rate-sheets/all';
public static GET_ALL_MASTPRC_RS_BASD = ApiEndpoints.BASE_URL + 'masterprice/get-rate-sheet/all';
public static NEW_SAVE_API = ApiEndpoints.BASE_URL + 'masterprice/ratesheet/save';


// location-controller
public static VIEW_ALL_LOCATIONPAIR = ApiEndpoints.BASE_URL+'location/get/all';
public static DELETE_LOC_BY_ID = ApiEndpoints.BASE_URL + 'location/origin/delete';
public static SAVE_ORGN_DSTN_BY_IATA = ApiEndpoints.BASE_URL + 'saveorgndstnbyiata';
public static SAVE_ORGN_DSTN_PAIR = ApiEndpoints.BASE_URL + 'location/iata/save';


// status-master-controller
public static SAVE_STATUS = ApiEndpoints.BASE_URL + 'status/save';
public static VIEW_ALL_SPECIFIC_STATUS = ApiEndpoints.BASE_URL + 'status/all-status-for-booking/get';
public static VIEW_ALL_STATUS = ApiEndpoints.BASE_URL + 'status/get/all';
public static VIEW_ALL_FILTERED_STATUS = ApiEndpoints.BASE_URL + 'status/all-status/get'
public static GET_STATUS_BY_ID = ApiEndpoints.BASE_URL + 'status/get';
public static UPDATE_STATUS_BY_ID = ApiEndpoints.BASE_URL + 'status/update';
public static DELETE_STATUS_BY_ID = ApiEndpoints.BASE_URL + 'status/delete';

// smart-flight-scheduled-controller
public static VIEW_ALL_HOPPING_ROUTES = ApiEndpoints.BASE_URL + 'hopping-route/get/all';
public static ADD_HOPPING_ROUTE = ApiEndpoints.BASE_URL + 'hopping-route/save';
public static VIEW_SPECIFIC_HOPPING_ROUTES = ApiEndpoints.BASE_URL + 'hopping-route/get';
public static DELETE_HOPPING_ROUTE = ApiEndpoints.BASE_URL + 'hopping-route/delete';

// document-upload-controller
public static UPLOAD_DOCS = ApiEndpoints.BASE_URL + 'document/save';
public static VIEW_DOCS = ApiEndpoints.BASE_URL + 'document/get/all';
public static DELETE_DOCS = ApiEndpoints.BASE_URL + 'document/delete';

// PhonePe payment Gateway
public static SAVE_PAYMENT_INITIALIZE_PHONEPE = ApiEndpoints.BASE_URL + 'payment/phonepe/initialize/save';

// RazorPay Payment Gateway
public static SAVE_PAYMENT_INITIALIZE_RAZORPAY = ApiEndpoints.BASE_URL + 'razorpay/create-order';

// payment Gateway
public static SAVE_PAYMENT_INITIALIZE = ApiEndpoints.BASE_URL + 'payment/payu/initialize/save';
public static GET_TRANSACTIONS_BOOKID = ApiEndpoints.BASE_URL + 'payment/payu/trnsctn-data-by-bookid/get';
public static GET_TRANSACTION_DETAILS = ApiEndpoints.BASE_URL + 'payment/payu/response/get';
public static UPDATE_PAYMENT_STATUS = ApiEndpoints.BASE_URL + 'payment/payu/bkng-pymnt-status/update';
public static GET_ALL_TRANSACTION_MICRO = ApiEndpoints.BASE_URL + 'payment/payu/mcrshpr-pymnt-rspns/get';
public static RECEIPT_FORM_SAVE = ApiEndpoints.BASE_URL + 'payment/payu/receipt-form/save';
public static MF_PAYMENT_UPDATE = ApiEndpoints.BASE_URL + 'payment/payu/pymnt-status/update';

// portmaster-controller
public static UPLOAD_PORTMASTER_CSV = ApiEndpoints.BASE_URL+ 'portmaster/csv/save';
public static VIEW_ALL_LOCATIONS = ApiEndpoints.BASE_URL+'portmaster/get/all';
public static SEARCH_IN_PORTMASTER = ApiEndpoints.BASE_URL + 'portmaster/get';
public static GET_ALL_COUNTRIES = ApiEndpoints.BASE_URL + 'portmaster/get/all/countries';
public static SEARCH_ORIGIN_DESTINATION = ApiEndpoints.BASE_URL +'portmaster/search-location/get'

// commodity-controller
public static SAVE_COMMODITY = ApiEndpoints.BASE_URL + 'commodity/merge/save';
public static VIEW_ALL_COMMODITY = ApiEndpoints.BASE_URL + 'commodity/merge/get/all';
public static DELETE_COMMODITY_ITEMS = ApiEndpoints.BASE_URL + 'commodity/category/merge/item/delete';
public static VIEW_COMMITEMS_FOR_COMMCAT = ApiEndpoints.BASE_URL + 'commodity/get-item-by-commodity';
public static VIEW_ALL_COMMODITY_PGNTN = ApiEndpoints.BASE_URL + 'commodity/merge/get-by-pagination-search/all';
public static VIEW_ALL_COMMODITY_NAMES = ApiEndpoints.BASE_URL + 'commodity/all-commodity-category/get';

// new-commodity-controller
public static GET_ALL_PRICE_CLASSIF = ApiEndpoints.BASE_URL + 'commodity/price-classification/get/all';
public static GET_ALL_COMMCAT_BY_PRICECLASSIF = ApiEndpoints.BASE_URL + 'commodity/merge/commodity-category/get/all-by-price-classification-id';
public static GET_ALL_COMMITM_BY_COMMCAT = ApiEndpoints.BASE_URL + 'commodity/merge/commodity-item/get/all-by-commodity-id';
public static SAVE_PRICECLASSIF = ApiEndpoints.BASE_URL + 'commodity/price-classification/save';
public static SAVE_COMM_CATEG = ApiEndpoints.BASE_URL + 'commodity/merge/commodity-category/save';
public static SAVE_COMM_ITM = ApiEndpoints.BASE_URL + 'commodity/merge/commodity-item/save';
public static SAVE_EDIT_PRCCLASSIF = ApiEndpoints.BASE_URL + 'commodity/price-classification/update';
public static SAVE_EDIT_COMM_CAT = ApiEndpoints.BASE_URL + 'commodity/merge/commodity-category/update';
public static SAVE_EDIT_COMM_ITM = ApiEndpoints.BASE_URL + 'commodity/merge/commodity-item/update';
public static GET_ALL_COMMCAT = ApiEndpoints.BASE_URL + 'commodity/merge/get/all';
public static GET_PRC_CLF_PGNT = ApiEndpoints.BASE_URL + 'commodity/all-price-classification-pagination-search/get';
public static GET_COMCAT_PGNT = ApiEndpoints.BASE_URL + 'commodity/all-commodity-category-pagination-search/get';
public static GET_COMITM_PGNT = ApiEndpoints.BASE_URL + 'commodity/all-commodity-category-item-pagination-search/get';


// admin-dashboard-data-controller
public static ADMIN_DASH_VALID_USERS = ApiEndpoints.BASE_URL + 'admin-dash/summary/registered-accounts';
public static ADMIN_DASH_COUNTS = ApiEndpoints.BASE_URL + 'admin-dash/summary/admin-data';
public static ADMIN_DASH_COMMODITY_COUNTS = ApiEndpoints.BASE_URL + 'admin-dash/summary/cmdtctg-item-count';
public static RATIO_CONVERION_DATA = ApiEndpoints.BASE_URL + 'admin-dash/summary/funnel-graph/get';
public static BOOKING_SUMMARY_INDIVISUAL = ApiEndpoints.BASE_URL + 'admin-dash/summary/daily-booking-stats-by-email/get';
public static BOOKING_POLAR_TAG_BASED = ApiEndpoints.BASE_URL + 'admin-dash/summary/tagname-email-count/get';
public static FREQUENT_DESTINATIONS = ApiEndpoints.BASE_URL + 'admin-dash/summary/shipment-destination-count/get';
public static REVENUE_VS_CHRGWGHT = ApiEndpoints.BASE_URL + 'admin-dash/summary/revenue-chargeweight/get';
public static LIVE_SHIPMENTS = ApiEndpoints.BASE_URL + 'admin-dash/summary/booking-by-pickupdate-currentdate/get';
public static MONTHLY_REVENUE = ApiEndpoints.BASE_URL + 'admin-dash/summary/monthly-revenue/get';
public static TILE_DATA = ApiEndpoints.BASE_URL + 'admin-dash/summary/shortcut-tile-data';
public static ALL_LOCATION_ON_MAP = ApiEndpoints.BASE_URL + 'admin-dash/summary/location-data/get';
public static YEARLY_CHARGBLE_WGHT = ApiEndpoints.BASE_URL + 'admin-dash/summary/yearly-chargble-weight-by-tag/get';
public static YEARLY_REVENUE = ApiEndpoints.BASE_URL + 'admin-dash/summary/yearly-revenue-by-tag/get';
public static DASHBOARD_ALL_GRAPHS = ApiEndpoints.BASE_URL + 'admin-dash/summary/dashboard-data/get';
public static MF_BOOKING_STATUS_SUMMARY = ApiEndpoints.BASE_URL + 'admin-dash/summary/mf-booking-status-summary/get';
public static MS_BOOKING_STATUS_SUMMARY = ApiEndpoints.BASE_URL + 'admin-dash/summary/ms-booking-status-summary/get';
// Goal Based Graphs
public static GET_ALL_GOAL_DATA = ApiEndpoints.BASE_URL + 'graph-goal/summary/get/all';
public static UPDATE_GOAL_DATA = ApiEndpoints.BASE_URL + 'graph-goal/summary/update';
public static CHRG_WGHT_DATA = ApiEndpoints.BASE_URL + 'graph-goal/summary/chargeweight-goal-graph/get';
public static REVENUE_GOAL = ApiEndpoints.BASE_URL + 'graph-goal/summary/totalprice-goal-graph/get';


// user-dashboard-data-controller
 public static USER_DASH_FREQUENT_CITIES = ApiEndpoints.BASE_URL + 'user-dash/summary/frequent-cities/get';

// grouping-controller
public static VIEW_ALL_GROUPS = ApiEndpoints.BASE_URL+ 'group/get/all';
public static UPDATE_GRP = ApiEndpoints.BASE_URL + 'group/update';
public static CREATE_GRP = ApiEndpoints.BASE_URL + 'group/save';
public static DEL_GRP = ApiEndpoints.BASE_URL + 'group/delete';
public static GET_PROF_BY_GRP = ApiEndpoints.BASE_URL + 'profile-group/profile/get';
public static GENERIC_GRP_PRFL = ApiEndpoints.BASE_URL + 'profile-group/save';
public static VIEW_ALL_URL_PERMS = ApiEndpoints.BASE_URL + 'group-url-permission/get/all';
public static VIEW_GRP_PERMS = ApiEndpoints.BASE_URL + 'group-url-permission/by-groupid/get';
public static UNALLOCATED_PROFILES = ApiEndpoints.BASE_URL + 'profile-group/not-in';
public static UNALLOCATED_URL = ApiEndpoints.BASE_URL + 'group-url-permission/not-in';
public static SAVE_GRPURLPRMS = ApiEndpoints.BASE_URL + 'group-url-permission/save';
public static UPDATE_GRPURLPRMS = ApiEndpoints.BASE_URL + 'group-url-permission/update';
public static DELETE_GRP_URL_PRMNS = ApiEndpoints.BASE_URL + 'group-url-permission/delete';
public static GET_GRPID_BY_EMAIL = ApiEndpoints.BASE_URL + 'group/data/get';

// Custom Grouping
public static GET_CSTM_GRPS = ApiEndpoints.BASE_URL + 'custom-user-group/all-groups-by-user-email/get';
public static SAVE_CSTM_GRPS = ApiEndpoints.BASE_URL + 'custom-user-group/save';
public static NOT_IN_CSTM_GRP = ApiEndpoints.BASE_URL + 'custom-user-group/not-in-group/get';
public static ADD_PENDING_FWD = ApiEndpoints.BASE_URL + 'custom-user-group/add-companies-to-custom-group';
public static DEL_ADDED_FWD = ApiEndpoints.BASE_URL + 'custom-user-group/delete-companies-from-custom-group';
public static DSBL_CSTM_GRPS = ApiEndpoints.BASE_URL + 'custom-user-group/dsbl-status/update';

//URL controller
public static VIEW_ALL_URLS = ApiEndpoints.BASE_URL + 'url/get/all';
public static UPDATE_URL_DATA = ApiEndpoints.BASE_URL + 'url/update';
public static SAVE_URL_DATA = ApiEndpoints.BASE_URL + 'url/save';
public static DELETE_URL_DATA = ApiEndpoints.BASE_URL + 'url/delete';

// Graph Group controller
public static GET_GRAPH_PRMNS = ApiEndpoints.BASE_URL + 'graph-group/summary/graph-by-email/get/all';
public static GRANT_GRAPH_PRMNS = ApiEndpoints.BASE_URL + 'graph-group/summary/graph-group-permission/save';
public static REVOKE_GRAPH_PRMNS = ApiEndpoints.BASE_URL + 'graph-group/summary/graph-group-permission/delete';



//UI URL CONTROLLER
public static GET_ALL_UI_URL = ApiEndpoints.BASE_URL + 'ui-url/normal-response/get/all';
public static DELETE_UI_URL = ApiEndpoints.BASE_URL + 'ui-url/delete';
public static SAVE_UI_URL = ApiEndpoints.BASE_URL + 'ui-url/save';
public static UPDATE_UI_URL = ApiEndpoints.BASE_URL + 'ui-url/update';
public static GET_CSTM_UI_URL = ApiEndpoints.BASE_URL + 'ui-url/custom-response/get/all';
public static ARRANGE_UI_URL = ApiEndpoints.BASE_URL + 'ui-url/sequence-id/update';

//UI URL GRP PERMISSION
public static GET_GRP_PRMS_BY_GRPID = ApiEndpoints.BASE_URL + 'ui-url-grp-prmn/by-grpId/get';
public static UPDATE_URL_GRP_PRMS = ApiEndpoints.BASE_URL + 'ui-url-grp-prmn/update';
public static GET_NOTIN_GRP_PRMS_BY_GRPID = ApiEndpoints.BASE_URL + 'ui-url-grp-prmn/not-in';
public static SAVE_GRP_PRMS = ApiEndpoints.BASE_URL + 'ui-url-grp-prmn/save';
public static CHECK_UI_FOR_EMAIL = ApiEndpoints.BASE_URL + 'ui-url/check-uiurl-permission';

//DATA TAG CONTROLLER
public static GET_ALL_DATATAG = ApiEndpoints.BASE_URL + 'data-tag/get/all';
public static SAVE_DATATAG = ApiEndpoints.BASE_URL + 'data-tag/save';
public static GET_DATA_BY_TAG = ApiEndpoints.BASE_URL + 'data-tag/user-tag-data/get';
public static UPDATE_DATATAG = ApiEndpoints.BASE_URL + 'data-tag/add-tag-value/update';
public static UPDATE_DATATAGNM = ApiEndpoints.BASE_URL + 'data-tag/update';
public static DELETE_DATATAG_VALUE = ApiEndpoints.BASE_URL + 'data-tag/tag-value/delete';

// TICKET SYSTEM
public static SAVE_TICKET = ApiEndpoints.BASE_URL + 'ticket-system/save';
public static GET_TICKET_LIST = ApiEndpoints.BASE_URL + 'ticket-system/disable-false/get/all'
public static ASSIGN_TICKET = ApiEndpoints.BASE_URL + 'ticket-system/assign-to/update';
public static ASSIGN_TO_ME = ApiEndpoints.BASE_URL + 'ticket-system/assign-to/get/all';
public static CHANGE_STATUS = ApiEndpoints.BASE_URL + 'ticket-system/query-solved/update';
public static SAVE_THREAD = ApiEndpoints.BASE_URL + 'ticket-system/thread/save';
public static GET_THREAD = ApiEndpoints.BASE_URL + 'ticket-system/thread/get/all'
public static GET_BY_CRTD = ApiEndpoints.BASE_URL + 'ticket-system/created-by/get/all';

// Track Booking
public static GET_ID_BY_TRACKING = ApiEndpoints.BASE_URL + 'booktrack/track-by-bookid/get/all';
public static GET_AWB_BY_TRACKING = ApiEndpoints.BASE_URL + 'booktrack/book-track-by-awbnum/get';
public static GET_BKNG_ID_FRM_AWB = ApiEndpoints.BASE_URL + 'booktrack/bookingdata-by-awbnum/get';

// AWB Number
public static ASSIGN_AWB_FRWRDR_SAVE = ApiEndpoints.BASE_URL + 'awbnumber/asgn-awb-frwrdr/save';
public static SHOW_ALL_AWB_TO_GSA = ApiEndpoints.BASE_URL + 'awbnumber/all-asgnd-awb-to-frwrdr/get';
public static SHOW_ALL_AWB_TO_FRWRD = ApiEndpoints.BASE_URL + 'awbnumber/all-asgnd-awb-by-gsa/get';
public static ASSIGN_AWB_TO_BOOKING_BY_FORWARDER = ApiEndpoints.BASE_URL + 'awbnumber/frwrdr-assign-awb-booking/save';
public static GET_ALL_AWB_NUMBERS = ApiEndpoints.BASE_URL + 'awbnumber/get-by-pagination-search/all';
public static GET_AVAILABLE_AWB = ApiEndpoints.BASE_URL + 'awbnumber/get/all';
public static SAVE_AWB_NUMBERS = ApiEndpoints.BASE_URL + 'awbnumber/csv/save';
public static ASSIGN_AWB_TO_BOOKING = ApiEndpoints.BASE_URL + 'awbnumber/awbnum-assign-booking/save';
public static FETCH_AWB_DATA = ApiEndpoints.BASE_URL + 'awbnumber/generate-awb/get';
public static GET_ALL_AIRLINES_AWB_NO = ApiEndpoints.BASE_URL + 'awbnumber/get-by-airline-search/all';
public static FETCH_AWB_DATA_FOR_GENERATION = ApiEndpoints.BASE_URL + 'airwaybill/airwaybill-generate-summery/get';
public static SAVE_AWB = ApiEndpoints.BASE_URL + 'airwaybill/save';
public static VIEW_ALL_SAVED_AWB = ApiEndpoints.BASE_URL + 'airwaybill/get-all';
public static GET_SINGLE_AWB = ApiEndpoints.BASE_URL + 'airwaybill/airwaybill-by-awb-number/get';
public static PUBLISH_MAWB = ApiEndpoints.BASE_URL + 'airwaybill/publish/airway-bill';
public static ASSIGN_AWB_NUMBER = ApiEndpoints.BASE_URL + 'awbnumber/assign-awb-to-booking';
public static GET_ALL_AWB_LIST = ApiEndpoints.BASE_URL + 'awbnumber/get-awb-all/new';
public static AWB_GET_BY_BOOKINGID = ApiEndpoints.BASE_URL +'awbnumber/getByBookingId';

// HAWB Number
public static GET_HAWB_BASED_ON_AWB = ApiEndpoints.BASE_URL + 'hawbnumber/by-awb/all-hawbnum/get';
public static SAVE_HAWB = ApiEndpoints.BASE_URL + 'hawbnumber/csv/save';
public static ASSIGN_HAWB = ApiEndpoints.BASE_URL + 'hawbnumber/save';
public static VIEW_AVAILABLE_HAWB = ApiEndpoints.BASE_URL + 'hawbnumber/by-bookid/all-hawbnum/get';
public static VIEW_ALL_HAWB = ApiEndpoints.BASE_URL + 'hawbnumber/awb-hawb-shipper-data/get'
public static VIEW_ALL_HAWB_PGNTN = ApiEndpoints.BASE_URL + 'hawbnumber/get-by-pagination-search/all'
public static UPDATE_HAWB = ApiEndpoints.BASE_URL + 'hawbnumber/awb-hawb-shipper-data/update';
public static GET_HAWB_SUMMARY = ApiEndpoints.BASE_URL + 'houseairwaybill/generate-summary/get';
public static SAVE_HAWB_JSON = ApiEndpoints.BASE_URL + 'houseairwaybill/save';
public static GET_SAVED_HAWB_JSON = ApiEndpoints.BASE_URL + 'houseairwaybill/get-all';
public static GET_SINGLE_HAWB = ApiEndpoints.BASE_URL + 'houseairwaybill/by-hawb-and-awb-number/get';
public static PUBLISH_HAWB = ApiEndpoints.BASE_URL + 'houseairwaybill/publish/houseairway-bill';
public static HAWB_ASSIGN_NEW = ApiEndpoints.BASE_URL +'hawbnumber/assign-hawb-to-booking-dimensions';
public static HAW_GET_DIMENTION_ID = ApiEndpoints.BASE_URL +'hawbnumber/hawb-by-booking/get-all';

// Currency Module
public static GET_ALL_CURRENCY = ApiEndpoints.BASE_URL + 'currency/get-by-pagination-search/all';
public static SAVE_CURRENCY = ApiEndpoints.BASE_URL + 'currency/save';
public static UPDATE_CURRENCY = ApiEndpoints.BASE_URL + 'currency/update';

// Tax Module
public static TAX_DETAILS_GET_ALL = ApiEndpoints.BASE_URL + 'taxdetails/get/all';
public static TAX_DETAILS_SAVE = ApiEndpoints.BASE_URL + 'taxdetails/save';

//Supplier Module
public static SUPPLIER_MODULE_GET_ALL = ApiEndpoints.BASE_URL + 'supplierdetails/get/all';
public static SUPPLIER_MODULE_SAVE = ApiEndpoints.BASE_URL + 'supplierdetails/save';
public static SUPPLIER_MODULE_GET_BY_ID = ApiEndpoints.BASE_URL + 'supplierdetails/by-id/get';

// Company Module
public static COMPANY_GET_ALL = ApiEndpoints.BASE_URL + 'customerrdetails/get/all';
public static COMPANY_SAVE = ApiEndpoints.BASE_URL + 'customerrdetails/save';
public static COMPANY_GET_BY_ID = ApiEndpoints.BASE_URL + 'customerrdetails/by-id/get';
public static ASSIGN_PROFILE = ApiEndpoints.BASE_URL + 'customerrdetails/assign-company-to-profile/save';
public static CUSTOMER_DETAILS_BY_EMAIL = ApiEndpoints.BASE_URL + 'customerrdetails/get-by-email/all';
public static CUTOMER_DETAILS_ONLY_BKNG = ApiEndpoints.BASE_URL + 'customerrdetails/all-companydata-by-bookings/get';

//Invoice Settings
public static INVOICE_SETTINGS_GET_ALL = ApiEndpoints.BASE_URL + 'invoicesetting/get/all';
public static INVOICE_SETTINGS_SAVE = ApiEndpoints.BASE_URL + 'invoicesetting/save';
public static INVOICE_SETTINGS_GET_BY_ID = ApiEndpoints.BASE_URL + 'invoicesetting/by-id/get';
public static INVOICE_MICRO = ApiEndpoints.BASE_URL + 'invoicedetails/ms-invoice-preview/get';



// Invoice Details
public static INVOICE_DETAILS = ApiEndpoints.BASE_URL + 'invoicedetails/generate-invoice/get';
public static INVOICE_SAVE = ApiEndpoints.BASE_URL + 'invoicedetails/save';
public static INVOICE_GET_ALL = ApiEndpoints.BASE_URL + 'invoicedetails/get/all';
public static INVOICE_GET_ALL_MICRO = ApiEndpoints.BASE_URL + 'invoicedetails/all-ms-invoice/get';
public static INVOICE_SAVE_MICRO = ApiEndpoints.BASE_URL + 'invoicedetails/ms-invoice/save';
public static PREVIEW_INVOICE_MICRO = ApiEndpoints.BASE_URL + 'invoicedetails/ms-invoice/by-bkng-id/get';

//Invoice Status
public static INVOICE_STATUS_GET = ApiEndpoints.BASE_URL + 'invoicestatus/get/all';
public static INVOICE_UPDATE = ApiEndpoints.BASE_URL + 'invoicedetails/update';

// Coupon
public static CREATE_COUPON = ApiEndpoints.BASE_URL + 'discount-coupon/save';
public static GET_ALL_COUPONS = ApiEndpoints.BASE_URL + 'discount-coupon/get/all';
public static UPDATE_COUPONS = ApiEndpoints.BASE_URL + 'discount-coupon/update';
public static GET_SINGLE_COUPON = ApiEndpoints.BASE_URL + 'discount-coupon/get';
public static DELETE_COUPON = ApiEndpoints.BASE_URL + 'discount-coupon/delete';

// Company Doc Structure
public static SAVE_COMPANY_DOC_STRUCT = ApiEndpoints.BASE_URL + 'company-document-structure/save';
public static GET_COMPANY_DOC_STRUCT = ApiEndpoints.BASE_URL + 'company-document-structure/get/all';
public static DELETE_COMPANY_DOC_STRUCT = ApiEndpoints.BASE_URL + 'company-document-structure/delete';
public static GET_COMPANY_STRUCT_BY_ID = ApiEndpoints.BASE_URL + 'company-document-structure/get';
public static UPDATE_COMPANT_STRUCT_DOC = ApiEndpoints.BASE_URL + 'company-document-structure/update';

// Commodity Doc Structure
public static GET_ALL_COMMODITY_STRUCT = ApiEndpoints.BASE_URL + 'commodity-document-structure/get/all';
public static SAVE_COMMODITY_STRUCT = ApiEndpoints.BASE_URL + 'commodity-document-structure/save';
public static DELETE_COMMODITY_DOCUMENT_STRUCT = ApiEndpoints.BASE_URL + 'commodity-document-structure/delete';
public static GET_COMMODITY_DOCUMENT_STRUCT_BY_ID = ApiEndpoints.BASE_URL + 'commodity-document-structure/get';
public static UPDATE_COMMODITY_DOCUMENT_STRUCT = ApiEndpoints.BASE_URL + 'commodity-document-structure/update';

// Document Reference
public static SAVE_DOC_REF = ApiEndpoints.BASE_URL + 'document-reference/save';
public static GET_ALL_DOC_REF = ApiEndpoints.BASE_URL + 'document-reference/get/all';
public static GET_DOC_REF_BY_ID = ApiEndpoints.BASE_URL + 'document-reference/get';
public static UPDATE_DOC_REF = ApiEndpoints.BASE_URL + 'document-reference/update';

// Table Reference
public static SAVE_TABLE_REF = ApiEndpoints.BASE_URL + 'table-reference/save';
public static GET_TABLE_REF = ApiEndpoints.BASE_URL + 'table-reference/get/all';

//Transhipment Docume controller
public static DOCS_BY_BOOKINGID_GET = ApiEndpoints.BASE_URL +'bkngdcmntrlstn/by-booking/get';
public static DOCS_DELETE = ApiEndpoints.BASE_URL +'bkngdcmntrlstn/delete';
public static DOCS_DELETE_FROM_SERVER = ApiEndpoints.BASE_URL +'bkngdcmntrlstn/deleteFileFromServer';
public static DOCS_DOWNLOAD = ApiEndpoints.BASE_URL +'bkngdcmntrlstn/download';
public static DOCS_DOWNLOAD_BOOKING = ApiEndpoints.BASE_URL +'bkngdcmntrlstn/downloadFile/Booking';
public static DOCS_SAVE = ApiEndpoints.BASE_URL +'bkngdcmntrlstn/save';

// Comodity Actual Data
public static GET_COMDT_DOC_BY_BKGID = ApiEndpoints.BASE_URL + 'commodity-actual-data/by-booking-id/get';
public static SAVE_COMDITY_ACT_DATA = ApiEndpoints.BASE_URL + 'commodity-actual-data/save';
public static UPDATE_COMDITY_ACT_DATA = ApiEndpoints.BASE_URL + 'commodity-actual-data/update';
public static GET_DOWNLOAD_FILE = ApiEndpoints.BASE_URL + 'commodity-actual-data/download';
public static GET_DELETE_FILE = ApiEndpoints.BASE_URL + 'commodity-actual-data/deleteFileFromServer';

// Company Actual data
public static GET_ACTUAL_COMPANY_DOCS = ApiEndpoints.BASE_URL + 'company-actual-data/by-company-id/get';
public static SAVE_COMPANY_FILES = ApiEndpoints.BASE_URL + 'company-actual-data/save';
public static UPDATE_COMPANY_FILES = ApiEndpoints.BASE_URL + 'company-actual-data/update';
public static GET_DOWNLOAD_FILE_COMPANY = ApiEndpoints.BASE_URL + 'company-actual-data/download';
public static GET_DELETE_FILE_COMPANY = ApiEndpoints.BASE_URL + 'company-actual-data/deleteFileFromServer';
public static GET_ACTUAL_COMPANY_DOCS_BY_ID = ApiEndpoints.BASE_URL + 'company-actual-data/by-only-company-id/get';

// Notification Type
public static GET_ALL_NOTIFICATION_TYPE = ApiEndpoints.BASE_URL + 'notificationtype/get/all';
public static SAVE_NOTIFICATIONS_TYPE = ApiEndpoints.BASE_URL + 'notificationtype/userdef/save';
public static EDIT_SAVED_NOTIFICATIONS = ApiEndpoints.BASE_URL + 'notificationtype/update';

public static GET_NOTIF_DATA = ApiEndpoints.BASE_URL + 'notificationdata/get/all';
public static GET_SINGLE_NOTIF = ApiEndpoints.BASE_URL + 'notificationdata/by-id/get';
public static SAVE_USERDEF_NOTI = ApiEndpoints.BASE_URL + 'notificationdata/save';


// SAC Details
public static GET_ALL_SAC = ApiEndpoints.BASE_URL + 'sacdata/get/all';

// CSR Details
public static GET_CSR = ApiEndpoints.BASE_URL + 'csrdata/get';

// RSS FEED APIs
// public static GET_DASH_NEWS = 'https://rss.app/feeds/v1.1/oyx1SGAbWp5uOv2n.json';
public static GET_DASH_NEWS = 'https://newsdata.io/api/1/news';

// Country-State-City Api
public static GET_TOKEN_CNTRY_STAT_CTY = 'https://www.universal-tutorial.com/api/getaccesstoken';
public static GET_CNTRY = 'https://www.universal-tutorial.com/api/countries';
public static GET_STATE = 'https://www.universal-tutorial.com/api/states';




// MarketPlace
public static ALN_MP_SAVE = ApiEndpoints.BASE_URL + 'airlinemasterprice/save';
public static ALN_MP_VIEW = ApiEndpoints.BASE_URL + 'airlinemasterprice/get/all';
public static ALN_MP_VIEW_BY_EMAIL = ApiEndpoints.BASE_URL + 'airlinemasterprice/by-email/get/all';
public static ALN_DEL_MP = ApiEndpoints.BASE_URL + 'airlinemasterprice/delete';
public static ALN_MP_BY_ID = ApiEndpoints.BASE_URL + 'airlinemasterprice/by-id/get';
public static UPDATE_ALN_MP = ApiEndpoints.BASE_URL + 'airlinemasterprice/update';
public static AIRLINE_MP_AUDIT_LOGS = ApiEndpoints.BASE_URL + 'airlinemasterprice/audit-log-by-airline-masterprice-id/get';
public static AIRLINE_PREVIOUS_LOGS = ApiEndpoints.BASE_URL + 'airlinemasterprice/previous-log/get';


// GSA MASTERPRICE
public static GSA_GET_MARGIN = ApiEndpoints.BASE_URL + 'gsamasterprice/by-id/get';
public static SAVE_GSA_MASTERPRICE = ApiEndpoints.BASE_URL + 'gsamasterprice/save';
public static VIEW_ALL_GSA_MASTERPRICE = ApiEndpoints.BASE_URL + 'gsamasterprice/get/all';
public static VIEW_MY_GSA_MASTERPRICE = ApiEndpoints.BASE_URL + 'gsamasterprice/by-email/get/all';
public static DELETE_GSA_MASTERPRICE = ApiEndpoints.BASE_URL + 'gsamasterprice/delete';
public static GET_GSA_MP_DATA_ID = ApiEndpoints.BASE_URL + 'gsamasterprice/gsa-data-by-id/get';
public static UPDATE_GSA_MP = ApiEndpoints.BASE_URL + 'gsamasterprice/update';
public static GSA_GET_ALL_ORIGINS = ApiEndpoints.BASE_URL + 'gsamasterprice/origins/get/all';
public static GET_DSTN_BY_ORGN = ApiEndpoints.BASE_URL + 'gsamasterprice/destination-by-origin/get';
public static UPDATE_GSA_MP_PBLSH = ApiEndpoints.BASE_URL + 'gsamasterprice/publish/update';
public static GET_GSA_MP_LOGS_BY_ID = ApiEndpoints.BASE_URL + 'gsamasterprice/audit-log-by-gsa-masterprice-id/get';

// MICROFORWARDER
public static GET_MCFR_MP_FOR_MARGIN = ApiEndpoints.BASE_URL + 'ms/mfm/by-gsa-id/get';
public static SAVE_MCFR_MP = ApiEndpoints.BASE_URL + 'ms/mfm/clone/save';
public static GET_MY_MCFWD_MP = ApiEndpoints.BASE_URL + 'ms/mfm/all-data-by-email/get';
public static UPDATE_MCFWD_MP = ApiEndpoints.BASE_URL + 'ms/mfm/publish/update';
public static DELETE_MCFWD_MP = ApiEndpoints.BASE_URL + 'ms/mfm/delete';
public static GET_MCFWD_BY_ID = ApiEndpoints.BASE_URL + 'ms/mfm/data-by-id/get';
public static UPDATE_MCFWD_FULL_MP = ApiEndpoints.BASE_URL + 'ms/mfm/update';
public static MICRO_FWD_MP_LOGS = ApiEndpoints.BASE_URL + 'ms/mfm/audit-log-by-id/get';
public static MICRO_GSA_ALL_MP = ApiEndpoints.BASE_URL + 'ms/mfm/gsa-mp-all/get';
public static MICRO_FWD_MP_CSV_SAVE = ApiEndpoints.BASE_URL + 'ms/mfm/csv/save';
public static PREVIOUS_LOGS = ApiEndpoints.BASE_URL + 'ms/mfm/previous-log/get';
public static NEW_RATES_FROM_EXISTING_MP = ApiEndpoints.BASE_URL + 'ms/mfm/new-rates-from-existing-mp/get'
public static ADD_NEW_RATES_MF = ApiEndpoints.BASE_URL + 'ms/mfm/add-new-rates-for-booking/save';
public static BOOKING_PRICE_UPDATE = ApiEndpoints.BASE_URL + 'ms/mfm/booking-price/update';

// MICROSHIPMENT
public static MICRO_GET_RELATION = ApiEndpoints.BASE_URL + 'ms/gsa-mf-relation/get';
public static MICRO_SAVE_RELATION = ApiEndpoints.BASE_URL + 'ms/gsa-mf-relation/save';
public static MICRO_DELETE_RELATION = ApiEndpoints.BASE_URL + 'ms/gsa-mf-relation/delete';
public static MICRO_SHIPMENT_ESTIMATE = ApiEndpoints.BASE_URL + 'ms/mfm/merge/estimate/get';
public static MICRO_SHIPMENT_ESTIMATE_COUNT = ApiEndpoints.BASE_URL + 'ms/mfm/merge/estimate-airlines/count/get';

// Company Details and Type
public static GET_ALL_COMPANY_TYPE = ApiEndpoints.BASE_URL + 'company-type/get/all';
public static SAVE_COMPANY_TYPE = ApiEndpoints.BASE_URL + 'company-type/save';
public static GET_PROFILES_BY_COMPANY_TYPE = ApiEndpoints.BASE_URL + 'company-type/all-profiles-by-company-type/get';
public static UPDATE_COMPANY_DETAILS = ApiEndpoints.BASE_URL + 'customerrdetails/update';
public static GET_ALL_COMPANY_BY_TYPE = ApiEndpoints.BASE_URL + 'customerrdetails/by-company-type/get';
public static AIRLN_MISC_SAVE = ApiEndpoints.BASE_URL + 'customerrdetails/airline-misc/save';
public static MCSHIPPR_MISC_SAVE = ApiEndpoints.BASE_URL + 'customerrdetails/micro-shipper-misc/save';
public static MISC_DATA_GET = ApiEndpoints.BASE_URL + 'customerrdetails/company-miscellaneous-data/get';

// Estimate Based on GSA
public static ESTIMATE_GET = ApiEndpoints.BASE_URL + 'gsamasterprice/merge/estimate/get';
public static GET_ESTIMATE_COUNT = ApiEndpoints.BASE_URL + 'gsamasterprice/merge/estimate/count/get';


// Address Book
public static SAVE_ADDRESS_BOOK = ApiEndpoints.BASE_URL + 'shipper-address-book/save';
public static GET_MY_ADDRRSS_BK = ApiEndpoints.BASE_URL + 'shipper-address-book/by-forwarder-email/get';
public static GET_MY_ADDRRSS_BK_PGNTN = ApiEndpoints.BASE_URL + 'shipper-address-book/by-forwarder-email-pagination/get';
public static UPDATE_MY_ADDRESS_BK = ApiEndpoints.BASE_URL + 'shipper-address-book/update';
public static DELETE_MY_CONTACT = ApiEndpoints.BASE_URL + 'shipper-address-book/delete';

//quotation-controller
public static SAVE_QUOTATION = ApiEndpoints.BASE_URL + 'quotation/save';
public static GET_ALL_QUOTATION_MS = ApiEndpoints.BASE_URL + 'quotation/all-data/get';
public static GET_QUOTATION_DETAIL = ApiEndpoints.BASE_URL + 'quotation/by-id/get';
public static QUOTATION_APPROVE = ApiEndpoints.BASE_URL + 'quotation/approve';
public static GET_ALL_QUOTATION_MF = ApiEndpoints.BASE_URL + 'quotation/all-data/by-email/get';
public static QUOTATION_EXPIRE = ApiEndpoints.BASE_URL + 'quotation/expire/update';

//transpoint-controller
public static SAVE_TRANS_POINT_CSV = ApiEndpoints.BASE_URL + 'transpoint/by-csv/save';
public static SAVE_TRANS_POINT_FORM = ApiEndpoints.BASE_URL + 'transpoint/by-form/save';
public static VIEW_TRANS_POINT_BY_ID = ApiEndpoints.BASE_URL + 'transpoint/by-id/get';
public static VIEW_TRANS_POINT = ApiEndpoints.BASE_URL + 'transpoint/get/all';
public static UPDATE_TRANS_POINT = ApiEndpoints.BASE_URL + 'transpoint/active-status/update';
}
